import React, { FC } from 'react';
import { Props } from './types';
import { Container, ContentLoader } from './styles';

const Loader: FC<Props> = ({ opacity = 1 }) => {
  return (
    <Container>
      <ContentLoader
        viewBox="0 0 200 14.6"
        backgroundColor="#f1f1f1"
        $opacity={opacity}
      >
        <rect x="0" y="5" rx="3" ry="3" width="50" height="6" />
        <rect x="96" y="5" rx="3" ry="3" width="20" height="6" />
        <rect x="155" y="5" rx="3" ry="3" width="20" height="6" />
        <rect x="185" y="5" rx="3" ry="3" width="15" height="6" />
      </ContentLoader>
    </Container>
  );
};

export default Loader;
